import { IStep } from '../models/appointments.models';

export const STEP_ONE: IStep = {
  flow_slug: 'appointmentFlow',
  flow_version: 1,
  uuid: 'appointment_flow_step_one',
  heading: 'Let’s connect you with an expert',
  subtext:
    'Certain things can’t be done online. We can provide assistance by speaking over the phone. Book an appointment with one of our insurance experts and we’ll call when it suits you.',
  layout: '',
  settings: {
    align: 'center'
  },
  sections: [
    {
      uuid: 'available_appointments_section',
      heading: 'Available appointments',
      subtext: '',
      layout: '',
      settings: {
        card: true,
        hero: 'management-updatetraveldates'
      },
      elements: []
    },
    {
      uuid: 'contact_details',
      heading: 'Your contact details',
      subtext: '',
      layout: '',
      settings: {
        card: true,
        hero: 'people-tenant',
        columns: [
          ['first_name', 'email'],
          ['last_name', 'phone']
        ]
      },
      elements: [
        {
          uuid: 'first_name_question',
          subtext: '',
          layout: '',
          settings: {
            placeholder: 'Given name',
            text_transform: 'capitalization'
          },
          prompt: 'Given name',
          key: 'first_name',
          type: 'string',
          required: true
        },
        {
          uuid: 'last_name_question',
          subtext: '',
          layout: '',
          settings: {
            placeholder: 'Last name',
            text_transform: 'capitalization'
          },
          prompt: 'Last name',
          key: 'last_name',
          type: 'string',
          required: true
        },
        {
          uuid: 'email_question',
          subtext: '',
          layout: 'email_input',
          settings: {
            placeholder: 'Email address',
            text_transform: 'lowercase'
          },
          prompt: 'Email',
          key: 'email',
          type: 'string',
          required: true
        },
        {
          uuid: 'phone_question',
          subtext: '',
          layout: 'mobile_input',
          settings: {
            placeholder: '0410000000'
          },
          prompt: 'Mobile number',
          key: 'phone',
          type: 'string',
          required: true,
          validations: [
            {
              predicate: {
                operands: ['<phone|mobile_number_au>'],
                operator: 'any'
              },
              message: 'Please enter a valid Australian mobile number',
              layout: ''
            }
          ]
        }
      ]
    }
  ],
  data: {
    _flow_metadata: {
      current_page_uuid: 'appointment_flow_step_one'
    }
  },
  human: {},
  progress: 1,
  total_pages: 4,
  actions: {
    next: {},
    back: {}
  },
  analytics: {
    flow_slug: 'appointmentFlow',
    flow_version: 1,
    page_uuid: 'appointment_flow_step_one'
  }
};

export const STEP_TWO: IStep = {
  flow_slug: 'appointmentFlow',
  flow_version: 1,
  uuid: 'appointment_flow_step_two',
  heading: 'Your duty to answer honestly',
  layout: '',
  settings: {
    align: 'center',
    submit_label: 'Agree and continue'
  },
  sections: [
    {
      uuid: 'duty_of_disclosure_section',
      layout: '',
      heading: 'Before you proceed we just need you to read and understand your duty to answer honestly.',
      settings: {
        card: true
      },
      info: {
        settings: {
          align: 'under_heading'
        },
        content:
          '<p>To help us work out how we can protect you, we may need to ask you some questions. We will use your answers to decide what insurance we will offer, to calculate your premium, and to assess your claims.</p><p>It’s important that you answer honestly and with reasonable care. You’re answering for yourself and anyone else to whom the questions apply. If you’re unsure or need to check something, please do so before you answer.</p><p>If your answers are not accurate and complete, the policy may be cancelled, or treated as if it never existed, and claims may be denied or not paid in full.</p><p>You also need to decide whether the product offered is right for you. Our product offer, questions and other guidance are not a recommendation that the product is appropriate in your personal circumstances. No one knows your situation better than you do, so please read the PDS and consider whether the cover meets your needs.</p>'
      },
      elements: [
        {
          uuid: 'agree_duty_of_disclosure_question',
          layout: 'radio_button_group',
          settings: {
            choices: []
          },
          prompt:
            'By continuing to book an appointment you agree to your duty to answer honestly.',
          key: 'agree_duty_of_disclosure',
          type: 'choice',
          required: false
        }
      ]
    }
  ],
  data: {
    _flow_metadata: {
      current_page_uuid: 'appointment_flow_step_two'
    }
  },
  human: {},
  progress: 2,
  total_pages: 4,
  actions: {
    next: {},
    back: {}
  },
  analytics: {
    flow_slug: 'appointmentFlow',
    flow_version: 1,
    page_uuid: 'appointment_flow_step_two'
  }
};

export const STEP_THREE: IStep = {
  flow_slug: 'appointmentFlow',
  flow_version: 1,
  uuid: 'appointment_flow_step_three',
  heading: 'Keep these things in mind before you speak to us:',
  layout: '',
  settings: {
    align: 'center',
    submit_label: 'Book appointment'
  },
  interstitial: {
    type: 'default',
    settings: {
      icon: '/assets/svgs/common/loading-blue.svg',
      time: 4000
    },
    heading: 'Booking your appointment',
    content: []
  },
  sections: [
    {
      uuid: 'call_deflection_section',
      heading: 'Insurance discount',
      layout: '',
      settings: {
        hero: 'marketing-liablity',
        card: true
      },
      subtext:
        "<p>With { partnerName } you can rest assured you're already getting the best deal we can offer. <strong>Please note that we do not provide discounts over the phone.</strong></p>",
      elements: []
    },
    {
      uuid: 'authorised_persons_section',
      heading: 'Authorised contacts',
      layout: '',
      settings: {
        hero: 'management-authoriseperson',
        card: true
      },
      subtext:
        "<p>The policyholder and their listed authorised contacts are the only people allowed to discuss or make changes to a policy.</p><p>If you are not the policyholder or you haven't been authorised, we will need to first speak to the policyholder who can authorise others to discuss or make changes to their policy.</p>",
      elements: []
    },
    {
      uuid: 'advice_section',
      heading: 'General advice',
      layout: '',
      settings: {
        hero: 'communication-alert',
        card: true
      },
      subtext:
        'Any advice we provide is general in nature and does not take your personal circumstances into account.'
    },
    {
      uuid: 'calls_recorded_section',
      heading: 'Calls are recorded',
      layout: '',
      settings: {
        hero: 'communication-phone',
        card: true
      },
      subtext: 'All calls are recorded for quality and coaching purposes.'
    }
  ],
  data: {
    _flow_metadata: {
      current_page_uuid: 'appointment_flow_step_three'
    }
  },
  human: {},
  progress: 3,
  total_pages: 4,
  actions: {
    next: {},
    back: {}
  },
  analytics: {
    flow_slug: 'appointmentFlow',
    flow_version: 1,
    page_uuid: 'appointment_flow_step_three'
  }
};

export const STEP_FOUR: IStep = {
  flow_slug: 'appointmentFlow',
  flow_version: 1,
  uuid: 'appointment_flow_step_four',
  heading: 'Your appointment is confirmed',
  layout: '',
  settings: {
    align: 'center',
    submit_label: 'Return to dashboard'
  },
  sections: [
    {
      uuid: 'dB39r9vUFQLF9eph2W7hyA',
      layout: '',
      settings: {
        hero: 'people-tenant',
        card: true
      },
      heading: 'Appointment details',
      elements: [
        {
          uuid: 'review_first_name',
          subtext: '',
          layout: 'review',
          settings: {
            read_only: true,
          },
          prompt: 'Name',
          key: 'first_name',
          type: 'string',
          required: true
        },
        {
          uuid: 'review_phone',
          subtext: '',
          layout: 'review',
          settings: {
            read_only: true,
          },
          prompt: 'Mobile number',
          key: 'phone',
          type: 'string',
          required: true
        },
        {
          uuid: 'review_email',
          subtext: '',
          layout: 'review',
          settings: {
            read_only: true,
          },
          prompt: 'Email',
          key: 'email',
          type: 'string',
          required: true
        },
        {
          uuid: 'review_topic',
          subtext: '',
          layout: 'review',
          settings: {
            read_only: true
          },
          prompt: 'Topic',
          key: 'topic',
          type: 'string',
          required: true
        }
      ]
    }
  ],
  data: {
    _flow_metadata: {
      current_page_uuid: 'appointment_flow_step_four'
    }
  },
  human: {},
  progress: 4,
  total_pages: 4,
  actions: {},
  analytics: {
    flow_slug: 'appointmentFlow',
    flow_version: 1,
    page_uuid: 'appointment_flow_step_four'
  }
};

export const ERRORS: { [key: string]: string } = {
  UNKNOWN:
    '<p><strong>We’re sorry, something went wrong</strong></p><p>We’re working on resolving this. Please try again.</p>',
  NO_TIMESLOTS:
    '<p><strong>There aren’t any appointments available</strong></p><p>We’re working on resolving this. Please try again.</p>',
  MAX_TOTAL_APPOINTMENT_LIMIT:
    '<p><strong>You’re unable to book another appointment at this time</strong></p><p>You have two upcoming appointments. Please use these appointments to discuss all of your needs</p>',
  MAX_APPOINTMENT_IN_TIMESLOT_LIMIT:
    '<p><strong>The appointment slot has been filled</strong></p><p>Please select a new time to secure your appointment</p>'
};

export const TOPICS: { [key: string]: string } = {
  contactus: 'To speak with someone',
  new_business: 'Help with a new policy',
  update_policy: 'Help with an existing policy',
  payment: 'Help with payments',
  renewals: 'Help with renewing a policy',
  claim: 'Help with an existing claim',
  cancel_policy: 'Help with cancelling a policy',
  complaint: 'To discuss a complaint'
};
